const getEnvironmentValues = (env, { prefix , notMatching  })=>Object.keys(env).filter((e)=>e.startsWith(prefix) && e.indexOf(notMatching) < 0 && env[e] !== 'false' && env[e]
    ).map((e)=>e.substring(prefix.length)
    )
;
const parseEnvironmentString = (str)=>str.split(';').filter((kv)=>kv.includes('=')
    ).map((kv)=>kv.split(/=(.*)/)
    ).reduce((bi, [key, value])=>{
        if (key && value !== undefined) {
            bi[key] = value;
        }
        return bi;
    }, {})
;
const getFeatures = (prefix = 'FEATURE_', notMatching = 'FEATURE_CONFIGURATION_')=>{
    if (typeof window !== 'undefined') {
        throw new Error('[getFeatures] This function should not be called in the client side!');
    }
    return getEnvironmentValues(process.env, {
        prefix,
        notMatching
    });
};
const getFeatureConfigs = (prefix = 'FEATURE_CONFIGURATION_')=>{
    if (typeof window !== 'undefined') {
        throw new Error('[getFeatureConfigs] This function should not be called in the client side!');
    }
    const configs = {};
    const env = process.env;
    const configsKeys = Object.keys(env).filter((e)=>e.startsWith(prefix) && env[e] !== 'false' && env[e]
    );
    configsKeys.forEach((key)=>configs[key.substring(prefix.length)] = env[key]
    );
    return configs;
};
const getServerFeatureConfigs = ()=>getFeatureConfigs('SERVER_FEATURE_CONFIGURATION_')
;
const getBuildInfo = (name = 'BUILD_INFO')=>parseEnvironmentString(process.env[name] || '')
;
const getArrayOfStringsFromEnv = (envVar)=>{
    const value = process.env[envVar];
    if (!value) {
        return [];
    }
    return value.split(',').map((s)=>s.trim()
    );
};
const getBooleanFromEnv = (envVar, defaultValue = false)=>{
    const value = process.env[envVar];
    if (value === undefined) {
        return defaultValue;
    }
    return value.toLowerCase() === 'true';
};

export { getArrayOfStringsFromEnv, getBooleanFromEnv, getBuildInfo, getFeatureConfigs, getFeatures, getServerFeatureConfigs };
//# sourceMappingURL=environment-utils.js.map
